import { render, staticRenderFns } from "./searchDetail.vue?vue&type=template&id=31b42a77&scoped=true"
import script from "./searchDetail.vue?vue&type=script&lang=js"
export * from "./searchDetail.vue?vue&type=script&lang=js"
import style0 from "./searchDetail.vue?vue&type=style&index=0&id=31b42a77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b42a77",
  null
  
)

export default component.exports